import React, { type ComponentPropsWithoutRef, type PropsWithChildren } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { useShouldApplyFeatureToggle } from '@atlassian/jira-tmp-feature-toggle/src/controllers/use-should-apply-tmp-feature-toggle/index.tsx';
import { ToggleableFeatureSkeletonItem } from '@atlassian/jira-tmp-feature-toggle/src/ui/toggleable-feature-skeleton-item/index.tsx';

const TogglableFeatureSkeleton = ({
	children,
	...props
}: PropsWithChildren<ComponentPropsWithoutRef<typeof ToggleableFeatureSkeletonItem>>) => {
	const isEligibleForFeatureToggle = useShouldApplyFeatureToggle();

	if (isEligibleForFeatureToggle) {
		return <ToggleableFeatureSkeletonItem {...props}>{children}</ToggleableFeatureSkeletonItem>;
	}

	return props.hasFeature ? <>{children}</> : null;
};

export const WithFeatureToggle = ({
	feature,
	hasFeature,
	children,
}: PropsWithChildren<ComponentPropsWithoutRef<typeof ToggleableFeatureSkeletonItem>>) => (
	<JSErrorBoundary
		fallback={hasFeature ? () => <>{children}</> : 'unmount'}
		id="jiraTmpFeatureToggle"
		packageName="jiraNavigationAppsSidebarNextGen"
		teamName="jlove-makkuro"
	>
		<TogglableFeatureSkeleton feature={feature} hasFeature={hasFeature}>
			{children}
		</TogglableFeatureSkeleton>
	</JSErrorBoundary>
);
